export default {
  reset: (state) => {
    state.items = [];
    state.pagination = {
      page: 1,
    };
    state.isLoading = false;
  },
  setResponse: (state, response) => {
    state.items = response.items;
    state.pagination = response.pagination;
  },
  setPage: ({ pagination }, page) => {
    pagination.page = page;
  },
  setIsLoading: (state, isLoading) => {
    state.isLoading = isLoading;
  },
};
